export default function ContactMe() {
  return (
    <section id="Contact" className="contact--section">
      <div>
        <h2>Kontaktieren Sie mich</h2>
        <p className="text-lg">
          Ich freue mich, von Ihnen zu hören! Füllen Sie das folgende Formular aus und ich melde mich so bald wie möglich zurück.
          <br />
          <strong>Alternativ:</strong> Schreiben Sie mir direkt eine E-Mail an {" "}
          <a href="mailto:walid.alsibai@gmail.com">walid.alsibai@gmail.com</a>.
        </p>
      </div>

      <form
        className="contact--form--container"
        action="https://formspree.io/f/xrbklwnw"
        method="POST"
      >
        <div className="container">
          <label htmlFor="first-name" className="contact--label">
            <span className="text-md">Vorname</span>
            <input
              type="text"
              id="first-name"
              name="First Name"
              className="contact--input text-md"
              required
            />
          </label>

          <label htmlFor="last-name" className="contact--label">
            <span className="text-md">Nachname</span>
            <input
              type="text"
              id="last-name"
              name="Last Name"
              className="contact--input text-md"
              required
            />
          </label>

          <label htmlFor="email" className="contact--label">
            <span className="text-md">Email</span>
            <input
              type="email"
              id="email"
              name="Email"
              className="contact--input text-md"
              required
            />
          </label>

          <label htmlFor="phone-number" className="contact--label">
            <span className="text-md">Telefonnummer</span>
            <input
              type="tel"
              id="phone-number"
              name="Phone"
              className="contact--input text-md"
            />
          </label>

          <label htmlFor="message" className="contact--label full-width">
            <span className="text-md">Nachricht</span>
            <textarea
              id="message"
              name="Message"
              className="contact--input text-md"
              rows="5"
              required
            ></textarea>
          </label>


          <div className="form-button-wrapper">
            <button type="submit" className="btn btn-primary">
              Nachricht senden
            </button>
          </div>
        </div>
      </form>
    </section>
  );
}

